import hyperform from 'hyperform';
// We are using hyperform for validation
// Docs: https://hyperform.js.org/docs/
hyperform(window, {
    classes: {
        warning: 'c-input__error',
        valid: 'is-valid',
        invalid: 'is-invalid',
        validated: 'is-validated',
        userInvalid: 'is-user-invalid',
        inRange: 'is-in-range',
        outOfRange: 'is-out-of-range',
    }
});

// Set the warning after the label in case we are using labels right after input
// for floating labels
hyperform.setRenderer('attachWarning', (warning, element) => {
    if (element.nextElementSibling.nodeName === 'LABEL') {
        return element.parentNode.appendChild(warning);
    }
    return element.parentNode.insertBefore(warning, element.nextSibling);
});


export {
    hyperform
}
